import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';

const RegisterForm = () => {
  const [form, setForm] = useState({
    business_name: '',
    admin_name: '',
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError(''); // limpia error al escribir
  };

  const validateEmail = email => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    // Validaciones frontend
    const { business_name, admin_name, email, password } = form;
    if (!business_name || !admin_name || !email || !password) {
      setError('Todos los campos son obligatorios.');
      return;
    }

    if (!validateEmail(email)) {
      setError('El email no tiene un formato válido.');
      return;
    }

    try {
      const res = await api.post('/register', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      localStorage.setItem('business', JSON.stringify(res.data.business));
      const slug = res.data.business.slug;
      navigate(`/admin/${slug}`);
    } catch (err) {
      const mensaje = err.response?.data?.message || 'Error en el registro';
      setError(mensaje);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Registrar negocio</h2>

      <input
        name="business_name"
        placeholder="Nombre del negocio"
        value={form.business_name}
        onChange={handleChange}
        required
      />
      <input
        name="admin_name"
        placeholder="Tu nombre"
        value={form.admin_name}
        onChange={handleChange}
        required
      />
      <input
        name="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />
      <input
        name="password"
        type="password"
        placeholder="Contraseña"
        value={form.password}
        onChange={handleChange}
        required
      />

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <button type="submit">Crear cuenta</button>
    </form>
  );
};

export default RegisterForm;
